export const content = {
  headline: 'Benötigte Schneenasen',
  snowNoses: ['Gesamtanzahl', 'Stück'],
  snowNosesSquareMetre: ['pro Quadratmeter', 'Stück'],
}
